module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_IT-f6417c7271e5bb7e764036f9e5355b3d.svg";